module.exports = __webpack_public_path__ + "img/2.2_Chief-Investigators_7_Ivers.aa9eaac683fc5ff3c4df1376ecb72814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.2_Chief-Investigators_7_Ivers.png
// module id = 754
// module chunks = 0